module.exports = __webpack_public_path__ + "static/img/background-pattern.7fa17f85.svg";